<div 
  class="edit edit--dark theme-dark" 
  [ngClass]="{
    'edit--hide-left-column': !(showLeftColumn$ | async),
    'edit--hide-right-column': !(showRightColumn$ | async),
    'edit--hide-header': !(showHeader$ | async),
    'edit--hide-footer': !(showFooter$ | async)
  }">
  
  <!-- Header - Logo -->
  <a routerLink="/dashboard" class="edit__logo" *appFlagExternal></a>
  <a routerLink="/explore" class="edit__logo" *appFlagInternal></a>

  <!-- Header - Title -->
  <div class="edit__header-left" >
    <div class="edit__title" [title]="(selectedBookmark$ | async)?.title | textNormalize" (click)="handleChapterTitleClick()">
      <span class="edit__title-text">{{ (selectedBookmark$ | async)?.title | textNormalize }}</span>
      <div class="edit__title-icon">
        <fa-icon icon="pencil"></fa-icon>
      </div>
    </div>
  </div>

  <!-- Header - Toolbar -->
  <div class="edit__header-bar">
    <!-- Tools -->
    <div class="edit__toolbar-group">
      <button app-button class="mr-1" [selected]="(activeTool$ | async) == toolEnum.Select" (click)="handleSelectTool(toolEnum.Select)">
        <app-button-icon iconPlacement="left" [icon]="toolIcons[toolEnum.Select]" [label]="toolEnum.Select"></app-button-icon>
      </button>
      <button app-button class="mr-1" [selected]="(activeTool$ | async) == toolEnum.Hide" (click)="handleSelectTool(toolEnum.Hide)">
        <app-button-icon iconPlacement="left" [icon]="toolIcons[toolEnum.Hide]" [label]="toolEnum.Hide"></app-button-icon>
      </button>
      <button app-button class="mr-1" [selected]="(activeTool$ | async) == toolEnum.Label" (click)="handleSelectTool(toolEnum.Label)">
        <app-button-icon iconPlacement="left" [icon]="toolIcons[toolEnum.Label]" [label]="toolEnum.Label"></app-button-icon>
      </button>
      <button app-button class="mr-1" [selected]="(activeTool$ | async) == toolEnum.Paint" (click)="handleSelectTool(toolEnum.Paint)">
        <app-button-icon iconPlacement="left" [icon]="toolIcons[toolEnum.Paint]" [label]="toolEnum.Paint"></app-button-icon>
      </button>
    </div>

    <!-- Undo Redo -->
    <div class="edit__toolbar-group">
      <button app-button (click)="handleUndoClick()" matTooltip="Undo Hide" [disabled]="(activeTool$ | async) !== toolEnum.Hide && (activeTool$ | async) !== toolEnum.Select">
        <fa-icon icon="undo"></fa-icon>
      </button>

      <button app-button (click)="handleRedoClick()" matTooltip="Redo Hide" [disabled]="(activeTool$ | async) !== toolEnum.Hide && (activeTool$ | async) !== toolEnum.Select">
          <fa-icon icon="redo"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Header - Right -->
  <div class="edit__header-right">
    <!-- Help -->
    <app-help-menu
      class="mr-2"
      widgetVerticalPosition="bottom"
      widgetHorizontalPosition="right">
    </app-help-menu>

    <!-- User Profile -->
    <app-user-profile-pin class="mr-2"></app-user-profile-pin>

    <!-- Exit -->
    <app-edit-exit></app-edit-exit>
  </div>

  <!-- Scene - Left -->
  <div class="edit__scene-left">
    <app-navigation-context></app-navigation-context>
  </div>
    
  <!-- Scene -->
  <!-- Engine goes here-->
  <div class="edit__scene" #engineContainer>
    <app-engine-camera-bar class="edit__camera-bar" [showCenter]="true"></app-engine-camera-bar>
  </div>
    
  <!-- Scene - Right -->
  <div class="edit__scene-right" [ngSwitch]="view$ | async">
    <app-edit-document-context *ngSwitchCase="editViewEnum.Chapter"></app-edit-document-context>
    <app-edit-label-context *ngSwitchCase="editViewEnum.Label"></app-edit-label-context>
    <app-edit-paint-context *ngSwitchCase="editViewEnum.Paint"></app-edit-paint-context>
  </div>
  
  <!-- Footer - Left -->
  <div class="edit__footer-left">
    <app-edit-chapter-pagination *ngIf="(allChaptersReady$ | async)"></app-edit-chapter-pagination>
  </div>

  <!-- Footer - Bar -->
  <div class="edit__footer-bar">
    
    <!-- Breadcrumb - Only visible on node hover -->
    <div class="edit__breadcrumb" [ngClass]="{'edit__breadcrumb--hide': !(hoveredNode$ | async)}">
      <app-engine-breadcrumb></app-engine-breadcrumb>
    </div>

    <!-- Animation -->
    <div class="edit__animation" *ngIf="isAnimated">
      <app-engine-scrubber style="width: 400px"></app-engine-scrubber>
    </div>
  </div>

  <!-- Footer - Right -->
  <div class="edit__footer-right">
    <button app-button buttonType="outline" (click)="publishBookmark()" [disabled]="atBookmarkLimit || (saving$ | async)" *appFlagExternal>
      Publish
    </button>

    <!-- Save Bookmark -->
    <app-button-group *appFlagExternal>
      <button app-button buttonType="primary" style="width: 116px" (click)="handleSaveBookmark()" [disabled]="saving$ | async">
        <span *ngIf="atBookmarkLimit">Go Premium</span>
        <span *ngIf="!atBookmarkLimit">
          <app-spinner render="inline" *ngIf="saving$ | async" size="small" class="mr-1"></app-spinner>
          {{ (saving$ | async) ? 'Saving' : 'Save' }}
        </span>
      </button>
      <button app-button buttonType="primary" [matMenuTriggerFor]="fileMenuBookmarks" [disabled]="saving$ | async">
        <fa-icon icon="caret-up"></fa-icon>
      </button>
    </app-button-group>

    <!-- Save Module -->
    <app-button-group class="w-100" render="block" *appFlagInternal>
      <button app-button buttonType="primary" (click)="saveModule()" [disabled]="saving$ | async" class="flex-grow">
        Save Module
      </button>

      <button app-button buttonType="primary" [matMenuTriggerFor]="fileMenuModules" [disabled]="saving$ | async">
        <fa-icon icon="caret-up"></fa-icon>
      </button>
    </app-button-group>
  </div>

</div>

<mat-menu #fileMenuBookmarks="matMenu">
  <button mat-menu-item *ngIf="atBookmarkLimit" (click)="upgrade()">Go Premium</button>
  <mat-divider *ngIf="atBookmarkLimit"></mat-divider>
  <button mat-menu-item (click)="handleSaveBookmark()" [disabled]="atBookmarkLimit">Save</button>
  <button mat-menu-item (click)="saveBookmarkAs()" [disabled]="atBookmarkLimit">Save as ...</button>
</mat-menu>

<mat-menu #fileMenuModules="matMenu">
  <button mat-menu-item (click)="openInSceneEditor()">
    Open in Scene Editor...
  </button>

  <button mat-menu-item (click)="openInView()">
    Open in View...
  </button>

  <button mat-menu-item (click)="openInWidget()">
    Open in Widget...
  </button>
</mat-menu>
